import axios from 'axios';
const instance = axios.create({
    // baseURL: 'http://localhost:2323/api'
    // baseURL: 'http://13.212.19.110:9090/api'
    baseURL: 'https://kaivallaksh.raghuveerinfotech.com/api'
});
export default instance;